"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BpmnModelParser = void 0;
const xml2js = require("xml2js");
const index_1 = require("../../Errors/index");
const index_2 = require("./Parser/index");
class BpmnModelParser {
    async parseXmlToObjectModel(xml) {
        if (!xml) {
            throw new Error('The given xml string is invalid, because it is empty.');
        }
        const xmlParserOptions = {
            explicitArray: false,
            mergeAttrs: true,
        };
        const xmlParser = new xml2js.Parser(xmlParserOptions);
        try {
            const parsedObjectModel = await xmlParser.parseStringPromise(xml);
            const definitions = (0, index_2.parseDefinitions)(parsedObjectModel);
            return definitions;
        }
        catch (error) {
            const errorToThrow = (0, index_1.isAtlasEngineError)(error)
                ? error
                : new index_1.BadRequestError(error.message);
            errorToThrow.message = this.buildErrorMessage(error);
            errorToThrow.additionalInformation = {
                ...error.additionalInformation,
                originalErrorMessage: error.message,
            };
            throw errorToThrow;
        }
    }
    buildErrorMessage(error) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let errorMessage = 'Error';
        if ((_a = error.additionalInformation) === null || _a === void 0 ? void 0 : _a.definitionId) {
            errorMessage = `${errorMessage} in definition \`${(_b = error.additionalInformation) === null || _b === void 0 ? void 0 : _b.definitionId}\``;
        }
        if ((_c = error.additionalInformation) === null || _c === void 0 ? void 0 : _c.collaborationId) {
            errorMessage = `${errorMessage} in collaboration \`${(_d = error.additionalInformation) === null || _d === void 0 ? void 0 : _d.collaborationId}\``;
        }
        if ((_e = error.additionalInformation) === null || _e === void 0 ? void 0 : _e.processModelId) {
            errorMessage = `${errorMessage} in model \`${(_f = error.additionalInformation) === null || _f === void 0 ? void 0 : _f.processModelId}\``;
        }
        if ((_g = error.additionalInformation) === null || _g === void 0 ? void 0 : _g.flowNodeId) {
            errorMessage = `${errorMessage} at flow node \`${(_h = error.additionalInformation) === null || _h === void 0 ? void 0 : _h.flowNodeId}\``;
        }
        errorMessage = `${errorMessage}: ${error.message ? error.message : error}`;
        return errorMessage;
    }
}
exports.BpmnModelParser = BpmnModelParser;
//# sourceMappingURL=BpmnModelParser.js.map